import React, { useEffect, useState } from 'react'
import ReactApexChart from 'react-apexcharts'

const GraphCompletedJobCards = ({ completedJobCards }) => {
  const [options, setOptions] = useState({})

  useEffect(() => {
    setOptions({
      series: [{
        name: "Completed Job Cards",
        data: completedJobCards.quantity
      }],
      options: {
        chart: {
          height: 350,
          type: 'line',
          zoom: {
            enabled: false
          }
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          curve: 'straight'
        },
        title: {
          text: 'Completed Job Cards',
          align: 'center'
        },
        grid: {
          row: {
            colors: ['#f1f1f1', 'transparent'], // takes an array which will be repeated on columns
            opacity: 0.5
          },
        },
        xaxis: {
          categories: completedJobCards.uniqueDays,
        }
      },
    })
  }, [completedJobCards])

  return (
    <>
      {Object.keys(options).length !== 0 && <ReactApexChart options={options?.options} series={options?.series} type="area" className='w-full lg:p-2 ' height={'310'} />}
    </>
  )
}

export default GraphCompletedJobCards